const AMAP_TILES = [1, 2, 3, 4].map(
  (subdomain) =>
    `https://webrd0${subdomain}.is.autonavi.com/appmaptile` +
    "?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}"
);

export function createAmapPublicStyle() {
  return {
    version: 8,
    sources: {
      amap: {
        type: "raster",
        tiles: AMAP_TILES,
        tileSize: 256,
        minzoom: 0,
        maxzoom: 18,
        attribution: "© 高德地图"
      }
    },
    layers: [
      {
        id: "amap-raster",
        type: "raster",
        source: "amap",
        minzoom: 0,
        maxzoom: 19
      }
    ]
  };
}

export function isMapTileError(error) {
  const message = String(error?.error?.message ?? error?.message ?? "");
  return /tile|source|network|fetch/i.test(message);
}
